<template>
    <div class="tpl-editor-area-group" :class="tplClass" :style="getStyle">
        <div class="teag-scale" :style="getScaleStyle">
            <template v-for="(item, index) in dataList">
                <tpl-editor-area
                        :tplProjectId="item.projectId"
                        :tplType="item.type"
                        v-model="item.json"
                        :edit="edit"
                        :key="index"
                        :dragMoving="dragMoving"
                        :root-scale="scale"
                        :class="{'tpl-active': item.onlyId === activeId}"
                        @onOpenGroupDialog="onOpenGroupDialog"
                        @onOptionListClick="onOptionListClick"
                        @onMaterialImgClick="onMaterialImgClick"
                        @onTextBlur="onTextBlur"
                        @onTextFocus="onTextFocus"
                        @click.native="onTplClick(item)"
                        @onTextRowNumChange="onTextRowNumChange"
                        @onItemClick="onItemClick"
                        @onCssTextClick="onCssTextClick"
                        @addCache="addCache"
                        @onKeydown="onKeydown"
                        @onCutImg="onCutImg"
                        @onTableClick="onTableClick"
                ></tpl-editor-area>
            </template>
        </div>
    </div>
</template>
<script>
  import tplEditorArea from './tpl-editor-area';
  import {template_type_ppt} from '@/const.js';

  export default {
    components: {
      tplEditorArea
    },
    props: {
      dataList: Array,
      activeId: [String, Number],
      scale: {
        type: Number, default: 1
      },
      edit: {
        type: Boolean,
        default: true
      },
      dragMoving: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {}
    },
    computed: {
      getStyle() {
        if (this.dataList.length === 0) {
          return '';
        }
        let item = this.dataList[0].json;
        let w = +item.width * this.scale;
        let h = this.getHeight() * this.scale;
        return `width: ${w}px;height:${h}px`
      },
      getScaleStyle() {
        if (this.dataList.length === 0) {
          return '';
        }
        let item = this.dataList[0].json;
        let height = this.getHeight();
        return `transform:scale(${this.scale});width: ${item.width}px;height:${height}px`
      },
      tplClass() {
        let classArr = [];
        if (this.edit) {
          classArr.push('tpl-group-edit');
        }
        if (this.dataList && this.dataList.length > 0) {
          let item = this.dataList[0];
          let isAdmin = this.$store.getters['app/isSYSAdmin'];
          if (item.type === template_type_ppt && !isAdmin) { // 非系统管理员，ppt模板不能编辑
            classArr.push('disable-height');
          }
        }
        return classArr.join(' ');
      },
    },
    methods: {
      getHeight() {
        let height = 0;
        this.dataList.forEach((item) => {
          height += +item.json.height;
        });
        return height;
      },
      onTplClick(item) {
        this.$emit('onTplClick', item)
      },
      onOpenGroupDialog(item) {
        this.$emit('onOpenGroupDialog', item)
      },
      onOptionListClick(item) {
        this.$emit('onOptionListClick', item);
      },
      onMaterialImgClick(item, ev) {
        this.$emit('onMaterialImgClick', item, ev);
      },
      onTextFocus(item) {
        this.$emit('onTextFocus', item)
      },
      onTextBlur(ev, item) {
        this.$emit('onTextBlur', ev, item)
      },
      onTextRowNumChange() {
        this.$emit('onTextRowNumChange');
      },
      onItemClick(item) {
        this.$emit('onItemClick', item);
      },
      onCssTextClick(item) {
        this.$emit('onCssTextClick', item);
      },
      addCache() {
        this.$emit('addCache')
      },
      onKeydown(minusOrPlus, height) {
        this.$emit('onKeydown', minusOrPlus, height)
      },
      onCutImg(item) {
        this.$emit('onCutImg', item)
      },
      onTableClick(item) {
        this.$emit('onTableClick', item)
      }
    }
  }
</script>